import { useState } from "react";

/**
 * Circular portrait. Shows the photo at `src` if it exists; otherwise falls
 * back to the initials, so the layout works before the photo is added.
 * Drop the photo at public/images/james.webp to replace the initials.
 */
export default function Avatar({ src, alt, initials, className = "" }) {
  const [failed, setFailed] = useState(false);

  return (
    <div
      className={`aspect-square flex-shrink-0 overflow-hidden rounded-full bg-teal-50 ${className}`}
    >
      {!failed && src ? (
        <img src={src} alt={alt} className="h-full w-full scale-[1.35] object-cover object-[50%_0%] origin-[50%_38%]" onError={() => setFailed(true)} />
      ) : (
        <div className="flex h-full w-full items-center justify-center font-serif text-4xl text-teal-700" aria-label={alt}>
          {initials}
        </div>
      )}
    </div>
  );
}
